import React, { Component } from "react";
import { FormGroup, FormControl, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style.scss";
import Authentication from "../api/Authentication/AuthenticationService";
import { Input, Row, Col, Button } from "antd";
import loginBackground from "../images/custom_bg.png";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../redux/reducers/Users/actions";
import queryString from "query-string";

class forgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      password: null,
      confirmPassword: null,
    };
  }

  passwordOnChange = (e) => {
    this.setState({ password: e.target.value });
  };

  confirmPasswordOnChange = (e) => {
    this.setState({ confirmPassword: e.target.value });
  };

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.handleLogin();
    }
  };

  authenticate = (username, password) => {
    Authentication.authenticate({ id_no: username, password: password })
      .then((response) => {
        localStorage.setItem("user-auth", response.data.token);
        toast.success(`Welcome ${this.state.username}`, {
          position: toast.POSITION.TOP_CENTER,
        });
        this.props.history.push("/settings");
      })
      .catch((err) => {
        toast.error("Username or password incorrect", {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  updatePassword = (password, id) => {
    Authentication.updatePassword({ password }, id)
      .then((response) => {
        toast.success(`Password Updated Successfully`, {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((err) => {
        toast.error("Username or password incorrect", {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  handleLogin = () => {
    this.updatePassword(this.state.password, this.state.id);
  };

  enterPressed = (event) => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      //13 is the enter keycode
      this.updatePassword(this.state.password, this.state.id);
    }
  };
  componentDidMount() {
    const parsed = queryString.parse(window.location.search);
    this.setState({ id: parsed.id });
  }

  render() {
    return (
      <div className="Login" align="center">
        <Row gutter={24}>
          <Col span={24}>
            <form
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this._handleKeyDown(e);
                }
              }}
              onSubmit={this.handleSubmit}
            >
              <Row gutter={24} className="w-100 mb-5" align="center">
                <Col span={24} className=" mt-5">
                  <FormGroup controlId="logo" align="center">
                    <img
                      id="main-logo"
                      className="logo-login"
                      src={require("../images/logo.png")}
                      alt="Shards Dashboard"
                    />
                  </FormGroup>
                </Col>
                <Col span={24} className="w-100">
                  <FormGroup controlId="email" align="center"></FormGroup>
                </Col>
                <Col span={24} className="w-100">
                  <FormGroup controlId="email">
                    <FormControl
                      autoFocus
                      placeholder="PASSWORD"
                      className="large-rounded-input mr-3"
                      style={{ width: "170px" }}
                      onChange={this.passwordOnChange}
                      type="password"
                    />
                  </FormGroup>
                </Col>
                <Col span={24} className="w-100">
                  <FormGroup controlId="password">
                    <FormControl
                      className="large-rounded-input mr-3"
                      placeholder="CONFIRM PASSWORD"
                      onChange={this.confirmPasswordOnChange}
                      type="password"
                    />
                  </FormGroup>
                </Col>
                <Col span={24} className="w-100">
                  <Input
                    type="button"
                    className="red-rounded-button mr-3"
                    onClick={this.handleLogin}
                    value="SUBMIT"
                  ></Input>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
        <Button
          shape="circle"
          className="circle-floating-button"
          onClick={() => this.props.history.push("/main")}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { user: state.userData.user };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(forgetPassword);
